<template>
<div class="chapter">
<div class="inner_page">
<section>
<p class="center firstInSection"><i>For the LORD thy God is a consuming fire.</i></p>
<p class="right">Deuteronomy 4:24<br/>
(traditionally ascribed to Moses)</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter2.vue?56220cd7